<template>
  <v-app :style="backgroundStyle">
    <v-navigation-drawer app clipped absolute permanent expand-on-hover mini-variant color="_light_grey" height="100%" width="200">
      <div class="mt-0" v-for="page in pages" :key="page.title">
        <!-- <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-1 font-weight-bold _grey--text"> {{ $t(page.title) }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-list dense nav>
          <v-list-item v-for="item in page.items" :key="item.title" @click="changePageHandler(item.title)">
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="text-subtitle-2 _grey--text">{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
      </div>
    </v-navigation-drawer>

    <v-app-bar app clipped-left absolute color="_light_grey" height="60">
      <a @click="routerHandler('https://appstore.imacloud.com.tw/#/?locale=' + locale)">
        <v-img class="mr-5 mx-md-5" src="@/assets/smb.png" alt="imacloud logo" max-width="50" contain />
      </a>
      <h1>
        <a @click="routerHandler('https://appstore.imacloud.com.tw/#/?locale=' + locale)" class="text-h6 text-sm-h4 _blue--text font-weight-black">
          {{ $t('imacloud') }}
        </a>
      </h1>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="showBulletin=true">
            <v-icon>mdi-bullhorn</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('bulletin') }}</span>
      </v-tooltip>
      <v-menu offset-y nudge-bottom="10">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                <v-icon>mdi-web</v-icon>
                <span style="font-size: 0rem">{{ $t('language') }}</span>
              </v-btn>
            </template>
            <span>{{ $t('language') }}</span>
          </v-tooltip>
        </template>
        <v-list dense class="pa-0" color="_light_grey">
          <template v-for="item in localeItems">
            <v-list-item :key="item" @click="changeLocaleHandler(item)">
              <v-list-item-title>{{ $t(item) }} </v-list-item-title>
            </v-list-item>
            <v-divider class="ma-0" :key="'divider_' + item" />
          </template>
        </v-list>
      </v-menu>
      <v-tooltip bottom v-if="!isSignIn">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="signIn()">
            <v-icon>mdi-account</v-icon>
            <span style="font-size: 0rem">{{ $t('signIn') + '/' + $t('signUp') }}</span>
          </v-btn>
        </template>
        <span>{{ $t('signIn') + '/' + $t('signUp') }}</span>
      </v-tooltip>
      <v-menu offset-y nudge-bottom="10" v-else>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-btn icon v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                <v-avatar color="_blue" size="40">
                  <img v-if="isAvatar" :src="avatarPath" alt="picture" />
                  <span v-else class="_light_grey--text headline">{{ photoWord }}</span>
                </v-avatar>
              </v-btn>
            </template>
            <span>{{ signInDescription }}</span>
          </v-tooltip>
        </template>
        <v-list dense class="pa-0" color="_light_grey">
          <template v-for="item in accountItems">
            <v-list-item :key="item" @click="accountListHandler(item)">
              <v-list-item-title>{{ $t(item) }} </v-list-item-title>
            </v-list-item>
            <v-divider :key="'divider_' + item" />
          </template>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <Notify />
      <Loading />
      <v-container class="pa-0" fill-height fluid>
        <router-view />
      </v-container>
      <v-dialog v-model="showSuccessDialog" persistent max-width="300" transition="dialog-top-transition">
        <v-card class="mx-auto green darken-1 white--text">
          <v-card-title>{{ $t('hintSignUpSuccess') }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="_blue white--text" @click="showSuccessDialog = false">{{ $t('ok') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>

    <v-footer app absolute padless color="_light_grey">
      <v-col justify="between-space" class="text-center _grey--text text-body-2 font-weight-bold py-2" cols="12">
        {{ $t('copyright') }} ©{{ new Date().getFullYear() }} <strong>{{ $t('itri') }}</strong>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        {{ $t('contact') }}：{{ $t('itriContact') }}&nbsp;<a class="_blue--text" href="tel:0492345658">049-2345658</a>&nbsp;
        <a class="_blue--text" href="mailto:PNWang@itri.org.tw">PNWang@itri.org.tw</a>
      </v-col>
    </v-footer>

    <v-dialog v-model="showBulletin" persistent width="800">
      <v-card style="position: relative; width: 100%">
        <v-card-text class="text-center pt-8">
          <div class="ql-editor" v-html="bulletinContent" />
        </v-card-text>
        <v-card-actions>
          <v-checkbox v-model="isNoShowNext" :label="$t('hintNextTimeNotShow')"></v-checkbox>
          <v-spacer></v-spacer>
          <v-btn color="_blue" class="white--text" @click="closeBulletin()">{{ $t('close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showServiceDialog" persistent max-width="760">
      <TermsService @agree="agreeService()"/>
    </v-dialog>
  </v-app>
</template>

<script src="https://www.google.com/recaptcha/api.js" async defer></script>
<script>
import { mapState, mapGetters } from 'vuex';
import Notify from '@/components/Notify.vue';
import Loading from '@/components/Loading.vue';
import CommVar from '@/method/commVar';
import Db from '@/api/awsDb';
import User from './store/user';
import WebSocket from './store/webSocket';
import TermsService from './components/TermsService.vue';

export default {
  name: 'Portal',
  components: { Notify, Loading, TermsService },
  data: () => ({
    background: '',
    localUrl: `${window.location.origin}${window.location.pathname}`,
    remoteUrl: null,
    isSignUp: false,
    showSuccessDialog: false,
    showBulletin: false,
    isNoShowNext: false,
    bulletin: '',
    showServiceDialog: false,
  }),
  computed: {
    ...mapState('authenticate', ['isSignIn', 'user', 'userAttribute']),
    ...mapGetters('dbTable', ['productList', 'permissionId']),
    ...mapGetters('locale', ['locale', 'localeItems']),
    accountItems() {
      if (this.userAttribute.group === 'pass'){
        this.isSignUp = true;
        return ['modifyData', 'modifyPassword', 'signOut'];
      }
      else if (this.userAttribute.group === 'pending') return ['signOut'];
      else return ['signUp', 'signOut'];
    },
    pages() {
      let ary = [
        {
          title: 'application',
          items: [
            { title: 'main', text: this.$t('main'), icon: 'mdi-home' },
            { title: 'popularRankings', text: this.$t('popularRankings'), icon: 'mdi-star' },
            { title: 'newProducts', text: this.$t('newProducts'), icon: 'mdi-new-box' },
          ],
        },
        {
          title: 'others',
          items: [
            { title: 'downloadZone', text: this.$t('downloadZone'), icon: 'mdi-download' },
            { title: 'serviceSite', text: this.$t('serviceSite'), icon: 'mdi-hand-heart' },
          ],
        },
      ];
      if (this.isSignIn && this.isSignUp) {
        ary.push({
          title: 'account',
          items: [
            // { title: 'myApp', text: this.$t('myApp'), icon: 'mdi-table-account' },
            { title: 'myWishList', text: this.$t('myWishList'), icon: 'mdi-bookmark-plus-outline' },
            // { title: 'accountingInfo', text: this.$t('accountingInfo'), icon: 'mdi-account-cash' },
          ],
        });
        if (this.isPermit('usage')) {
          ary[ary.length - 1].items.push({ title: 'myApp', text: this.$t('myApp'), icon: 'mdi-table-account' });
          ary[ary.length - 1].items.push({ title: 'deployApp', text: this.$t('deployApp'), icon: 'mdi-application-export' });
          ary[ary.length - 1].items.push({ title: 'billInfo', text: this.$t('billInfo'), icon: 'mdi-account-cash' });
          ary[ary.length - 1].items.push({ title: 'accountingInfo', text: this.$t('accountingInfo'), icon: 'mdi-billboard' });  // [appStat]
        }
        if (this.isPermit('launch') || this.isPermit('audit') || this.isPermit('basicStatistics')) {
          ary[ary.length - 1].items.push({
            title: 'systemManage',
            text: this.$tc('systemManage', this.sysManageNameNo),
            icon: 'mdi-monitor-dashboard',
          });
        }
        if (this.isPermit('basicStatistics') || this.isPermit('basicQuery')) {
          ary[ary.length - 1].items.push({ title: 'statistics', text: this.$t('statistics'), icon: 'mdi-chart-bar' });
        }
        // ary[ary.length - 1].items.push({ title: 'chatService', text: this.$t('chatService'), icon: 'mdi-chat-processing' });
      }
      ary[ary.length - 1].items.push({ title: 'customerService', text: this.$t('customerService'), icon: 'mdi-face-agent' });
      return ary;
    },
    sysManageNameNo() {
      if (this.isPermit('basicStatistics')) return 2;
      if (this.isPermit('audit')) return 1;
      if (this.isPermit('launch')) return 0;
      return 0;
    },
    signInDescription() {
      if (!Object.keys(this.userAttribute).length) return '';
      if(!Object.prototype.hasOwnProperty.call(this.userAttribute, 'agreeService')) {
        this.showServiceDialog = true;
      }
      return this.userAttribute.name; //+ ' ' + this.$t(CommVar.userTypeText(this.userAttribute.userType));
    },
    backgroundStyle() {
      if (this.background.type === 'color') {
        return { backgroundColor: this.background.datas };
      } else {
        let url = 'url(./bg.jpg)';
        if (this.background.datas !== 'DEFAULT') {
          url = `url(${this.background.datas})`;
        }
        return { backgroundImage: url };
      }
    },
    isAvatar() {
      if (!Object.prototype.hasOwnProperty.call(this.userAttribute, 'avatar')) return false;
      if (this.userAttribute.avatar.type !== 'image') return false;
      return true;
    },
    avatarPath() {
      return process.env.VUE_APP_S3_URL + 'public/avatar/' + this.userAttribute.avatar.path;
    },
    photoWord() {
      if (!Object.keys(this.userAttribute).length) return '';
      return this.userAttribute.name[0];
    },
    isOauth() {
      return process.env.VUE_APP_SSO === 'oauth2';//CHERRY_TEST
      // return window.sessionStorage.getItem('isOauthTest')=== 'true';//CHERRY_TEST
    },
    bulletinContent() {
      return this.bulletin[this.locale];
    },
  },
  created() {
    const params = new URLSearchParams(window.location.search);//CHERRY_TEST
    if (params.get('code') !== null){
    //   window.sessionStorage.setItem('isOauthTest',true)//CHERRY_TEST
    }else{
    //   window.sessionStorage.setItem('isOauthTest',false)//CHERRY_TEST
      window.localStorage.removeItem('oauthRefreshToken');
      window.localStorage.removeItem('oauthCode');
    }
    window.sessionStorage.setItem('id', CommVar.randomId());
    let language = null;
    if (Object.keys(this.$route.query).length && Object.prototype.hasOwnProperty.call(this.$route.query, 'locale')) {
      language = this.$route.query.locale;
    } else {
      language = window.localStorage.getItem('locale');
    }
    if (language === null) {
      language = navigator.language.toLowerCase();
      if (language !== 'zh-tw' && language !== 'en-us') {
        language = 'en-us';
      }
    }
    this.changeLocaleHandler(language);
    if (Object.keys(this.$route.query).length && Object.prototype.hasOwnProperty.call(this.$route.query, 'deviceId')) { //CHERRY_TEST
      window.localStorage.setItem('deviceId', this.$route.query.deviceId);//CHERRY_TEST
    }//CHERRY_TEST
    if (this.isOauth) this.oauthProcess();
    else {
      this.$store
        .dispatch('authenticate/currentUser')
        .then((user) => {
          User.read(user.attributes.email).then((data) => {
            this.$store.commit('authenticate/setUserAttribute', data);
            if(data.group === 'pending'){
              this.showSuccessDialog = true;
            }
            if (!this.userAttribute.changePwTime || (new Date().getTime() - this.userAttribute.changePwTime) > (180 * 24 * 60 * 60 * 1000)) {
              this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('hintPwMaxAge')] });
            }
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
    this.$store.dispatch('dbTable/loadCategory').then(() => {
      this.$store.dispatch('dbTable/loadProduct').then(() => {});
    });
    this.$store.dispatch('dbTable/loadCustom');
    this.$store.dispatch('dbTable/loadPermission');

    Db.scan('info').then((res) => {
      this.background = res.find((x) => x.id === 'background');
    });
    Db.scan('info').then((res) => {
      this.bulletin = res.find((x) => x.id === 'notice-1').datas;
    });
    const expiredDate = window.localStorage.getItem('bulletinExpiredDate');
    if (expiredDate !== new Date().toLocaleDateString()) {
      this.showBulletin = true;
    }
    WebSocket.connect();
    this.$store.commit('authenticate/setUserUuid', CommVar.uuid());
  },
  methods: {
    oauthProcess() {
      let token = window.localStorage.getItem('oauthRefreshToken');
      const params = new URLSearchParams(window.location.search);
      // if (window.localStorage.getItem('deviceId') !== null) this.$store.commit('authenticate/setDeviceType', 'imacloud');
      if (params.get('code') === null) return;
      this.remoteUrl = params.get('redirect_uri');
      this.$store
        .dispatch('authenticate/oauthToken', {
          refreshToken: token,
          code: params.get('code'),
          localUrl: this.localUrl,
          remoteUrl: this.remoteUrl,
        })
        .then((result) => {
          window.localStorage.setItem('oauthRefreshToken', result.refreshToken);
          window.localStorage.setItem('oauthCode', params.get('code'));
          this.$store.dispatch('authenticate/oauthCurrentUser', { accessToken: result.accessToken }).then((user) => {
            User.read(user.attributes.email).then((data) => {
              if (data === undefined) {
                this.$router.push({ name: 'signUp', params: { redirectUrl: this.remoteUrl === null ? this.localUrl : this.remoteUrl } });
                return;
              } else if(data.group === 'pending'){
                this.showSuccessDialog = true;
              }
              // [cherry] migrate user pool ===
              const items = { ...data };
              if (user.attributes.cognitoId !== items.cognitoId) {
                User.update({ email: items.email, cognitoId: user.attributes.cognitoId });
                items.cognitoId = user.attributes.cognitoId;
              }
              this.$store.commit('authenticate/setUserAttribute', items);
              // ================================
              if (this.remoteUrl !== null) {
                this.$store.dispatch('authenticate/oauthSignInUrl', { redirectUrl: this.remoteUrl }).then((url) => {
                  this.routerHandler(url);
                });
              }
            });
          });
        })
        .catch((err) => {
          console.log(err)
          // window.sessionStorage.setItem('isOauthTest', false);//CHERRY_TEST
          this.$store.commit('notify/set', { type: 'alarm', msg: [this.$t('errLoginExpired')] });
          this.oauthSignOut(this.remoteUrl === null ? this.localUrl : this.remoteUrl);
        });
    },
    signIn() {
      //CHERRY_TEST->
      if (this.isOauth) {
        this.$store.dispatch('authenticate/oauthSignInUrl', { redirectUrl: this.localUrl }).then((res) => {
          this.routerHandler(res);
        });
      } else {
      //CHERRY_TEST<-
        this.changePageHandler('signIn');
      }
    },
    oauthSignOut(redirectUrl) {
      // window.sessionStorage.setItem('isOauthTest', false);//CHERRY_TEST
      // window.sessionStorage.setItem('isOauthSignInTest', false);//CHERRY_TEST
      this.$store.dispatch('authenticate/oauthSignOutUrl', { redirectUrl }).then((url) => {
        window.localStorage.removeItem('oauthRefreshToken');
        window.localStorage.removeItem('oauthCode');
        this.routerHandler(url);
      });
    },
    agreeService() {
      this.showServiceDialog = false;
      User.update({ email: this.userAttribute.email, agreeService: 1 });
    },
    isPermit(permission) {
      if (!this.isSignIn) return false;
      if (!Object.keys(this.userAttribute).length) return false;
      return Object.keys(this.userAttribute.policy).findIndex((x) => x === this.permissionId(permission)) !== -1;
    },
    changePageHandler(pageName, params = {}) {
      if (this.$route.name === pageName) return;
      switch (pageName) {
        case 'systemManage':
          // window.open('https://manager.imacloud.com.tw/admin?lang=' + this.locale + '&email=' + this.userAttribute.email);
          window.open('https://manager.imacloud.com.tw/admin');
          return;
        case 'billInfo':
          window.open('https://cashflow.imacloud.com.tw/pay/login');
          return;
        case 'myApp': {
          let list = [];
          if (this.userAttribute.ownApp) {
            if(this.userAttribute.ownApp[localStorage.getItem('deviceId')]){
              Object.keys(this.userAttribute.ownApp[localStorage.getItem('deviceId')]).forEach((element) => {
                let index = this.productList.find((x) => x.id === element);
                if (index !== undefined) list.push(index);
              });
            }
          }
          this.$store.commit('dbTable/setFilterList', list);
          this.$store.commit('dbTable/setFilterSubject', this.$t(pageName));
          if (this.$route.name === 'filterList') return;
          this.$router.push({ name: 'filterList' });
          return;
        }
        case 'myWishList': {
          const list = [];
          if (this.userAttribute.wishApp) {
            this.userAttribute.wishApp.forEach((element) => {
              let index = this.productList.find((x) => x.id === element);
              if (index !== undefined) list.push(index);
            });
          }
          this.$store.commit('dbTable/setFilterList', list);
          this.$store.commit('dbTable/setFilterSubject', this.$t(pageName));
          if (this.$route.name === 'filterList') return;
          this.$router.push({ name: 'filterList' });
          return;
        }
        default:
          this.$router.push({ name: pageName, params });
          return;
      }
    },
    routerHandler(href) {
      window.location.href = href;
    },
    accountListHandler(item) {
      switch (item) {
        case 'signOut':
          if (this.isOauth) this.oauthSignOut(this.localUrl);
          else {
            this.$store.dispatch('authenticate/signOut').then(() => {
              if (this.$route.path.indexOf('account') !== -1) {
                this.changePageHandler('main');
              }
            });
          }
          this.$store.commit('notify/set', { type: 'success', msg: [this.$t('signOut'), ' ', this.$t('success')] });
          break;
        case 'modifyPassword':
          this.changePageHandler('modifyPassword', 'modifyPassword');
          break;
        case 'modifyData':
          this.changePageHandler('modifyData', 'modifyData');
          break;
        case 'signUp':
          this.changePageHandler('signUp', { redirectUrl: this.remoteUrl === null ? this.localUrl : this.remoteUrl });
          break;
        default:
          break;
      }
    },
    changeLocaleHandler(lang) {
      this.$store.commit('locale/set', { locale: lang });
      window.localStorage.setItem('locale', lang);
      document.title = this.$t('imacloud');
    },
    closeBulletin() {
      if (this.isNoShowNext) {
        const expiredDate = new Date().toLocaleDateString();
        console.log(expiredDate);
        window.localStorage.setItem('bulletinExpiredDate', expiredDate);
      }
      this.showBulletin = false;
    },
  },
};
</script>

<style scoped>
/* #app { */
/* background-size: cover; */
/* background-image: url(~@/assets/bg.jpg); */
/* background-color: yellow; */
/* } */
button:focus {
  outline: 0;
}
</style>
